<template>
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-md-12 px-0">
          <top-navbar></top-navbar>
          <div class="col-md-6 offset-md-3 px-5">
            <h3 class="font-weight-bold d-inline-block">Details</h3>
            <sidebar-link to="/admin/enquiries" style="list-style-type: none; float: right;">
              <button class="btn backBtn">
                Back
              </button>
            </sidebar-link>
            <p>
              <b>Name:</b> {{ restDetails.name }}
            </p>
            <p>
              <b>Phone:</b> {{ restDetails.phone }}
            </p>
            <p>
              <b>Email:</b> {{ restDetails.email }}
            </p>
            <p>
              <b>Date of Birth:</b> {{ restDetails.dateOfBirth }}
            </p>
            <p>
              <b>Business Name:</b> {{ restDetails.businessName }}
            </p>
            <p>
              <b>Trading Name:</b> {{ restDetails.tradingName }}
            </p>
            <p>
              <b>Address:</b> {{ restDetails.address }}
            </p>
            <p>
              <b>Postcode:</b> {{ restDetails.postCode }}
            </p>
            <p>
              <b>Bank Name:</b> {{ restDetails.bankName }}
            </p>
            <p>
              <b>Sort Code:</b> {{ restDetails.sortCode }}
            </p>
            <p>
              <b>Account No:</b> {{ restDetails.bankAccountNo }}
            </p>
            <!-- <p>
              <b>Message:</b> {{ restDetails.msg }}
            </p> -->
            <p>
              <b>Status:</b> <span :style="restDetails.status == 'Pending' ? 'color: #F4522D' : restDetails.status == 'InProgress' ? 'color: #FF9500' : 'color: #57830d'">{{ restDetails.status }}</span>
            </p>
            <div class="float-right mt-1">
              <p v-if="isSuccess" style="color: green; font-weight: bold">Transferred to {{ restDetails.status }}</p>
              <button v-if="restDetails.status == 'Pending'" @click="() => updateStatus('InProgress')" class="btnComplete mx-2">
                Make InProgress
              </button>
              <button v-if="restDetails.status == 'InProgress'" @click="() => updateStatus('Completed')" class="btnInprogress mx-2">
                Make Completed
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 offset-md-3 px-5">
          <div>
            <label class="font-weight-bold">Name</label>
            <p v-if="notedByError" style="color: red; margin-bottom: 5px;">{{ notedByError }}</p>
            <input type="text" class="form-control" v-model="notedBy" placeholder="Enter Name" style="border: 1px solid;">
          </div>
          <div>
            <label class="font-weight-bold mt-3">Note</label>
            <p v-if="noteError" style="color: red; margin-bottom: 5px;">{{ noteError }}</p>
            <textarea class="form-control" v-model="note" placeholder="Enter Note" style="border: 1px solid;"></textarea>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <button @click="addNote" :disabled="isAddingNote" class="btn submitBtn">
              {{ isAddingNote ? 'Saving...' : 'Save' }}
            </button>
          </div>
        </div>
      </div>

      <div class="row mt-4 pb-5">
        <div class="col-md-6 offset-md-3 px-5">
          <div v-for="(note, i) in sortedNotes" :key="i">
            <p class="font-weight-bold">{{ note.name }}</p>
            <div style="width: 70%; display: flex; justify-content: space-between;">
              <p><b>Note:</b></p>
              <p>{{ note.date }}</p>
              <p>{{ note.time }}</p>
            </div>
            <p class="text-center">{{ note.note }}</p>
            <hr v-if="i < sortedNotes.length - 1" style="border: 1px solid;">
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TopNavbar from '../../layout/TopNavbar'
import logout from '../../mixins/logoutMixins.js'
import axios from 'axios'

export default {
  components: {
    TopNavbar
  },
  data () {
    return {
      restDetails: '',
      isSuccess: false,
      jwtToken: this.$cookies.get('token') || null,
      notedBy: '',
      note: '',
      notedByError: '',
      noteError: '',
      isAddingNote: false
    }
  },
  mixins: [logout],
  mounted () {
    this.getRestDetails()
  },
  computed: {
    sortedNotes () {
      let notes = (this.restDetails && this.restDetails.notes) || []
      return [...notes].sort((a, b) => this.noteTimestamp(b) - this.noteTimestamp(a))
    }
  },
  methods: {
    noteTimestamp (note) {
      let [day, month, year] = (note.date || '').split('/').map(Number)

      let [time, ampm] = (note.time || '').split(' ')
      let [hours, minutes] = (time || '').split(':').map(Number)
      if (ampm === 'PM' && hours !== 12) hours += 12
      if (ampm === 'AM' && hours === 12) hours = 0

      return new Date(year, month - 1, day, hours, minutes).getTime()
    },
    getRestDetails () {
        let url = process.env.VUE_APP_API_URL+'/api/restaurantRequest/find?id='+this.$route.query.id

        axios
        .get(url,
        {
          headers: {
            Authorization: `Bearer ${this.jwtToken}`,
          }
        })
        .then((data) => {
            this.restDetails = data.data


            if (data.status === 403) {
                let logoutResponse = this.logout()
                if (logoutResponse === 1) {
                    this.$router.push({ path: '/login' })
                }
            }
        })
    },
    updateStatus (status) {

      let url = process.env.VUE_APP_API_URL+'/api/restaurantRequest/update'
      let tempDetails = {...this.restDetails}
      tempDetails.status = status

      axios
      .post(url, tempDetails,
      {
        headers: {
          Authorization: `Bearer ${this.jwtToken}`,
        }
      })
      .then((data) => {
        this.restDetails.status = status
        this.isSuccess = true

        if (data.status === 403) {
          let logoutResponse = this.logout()
          if (logoutResponse === 1) {
            this.$router.push({ path: '/login' })
          }
        }
      })
    },
    addNote () {
      this.notedByError = ''
      this.noteError = ''

      if (!this.notedBy.trim()) {
        this.notedByError = 'Name is required'
        return
      }
      if (!this.note.trim()) {
        this.noteError = 'Note is required'
        return
      }

      this.isAddingNote = true

      let now = new Date()
      let date = now.getDate().toString().padStart(2, '0') + '/' + (now.getMonth() + 1).toString().padStart(2, '0') + '/' +  now.getFullYear()
      let hours = now.getHours()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      hours = hours % 12
      hours = hours ? hours : 12
      let time = hours.toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0') + ' ' + ampm

      let newNote = {
        name: this.notedBy,
        note: this.note,
        date: date,
        time: time
      }

      if (!this.restDetails.notes) {
        this.restDetails.notes = []
      }
      this.restDetails.notes.push(newNote)

      let url = process.env.VUE_APP_API_URL + '/api/restaurantRequest/update'
      let tempDetails = { ...this.restDetails }

      axios
        .post(url, tempDetails, {
          headers: {
            Authorization: `Bearer ${this.jwtToken}`,
          }
        })
        .then((data) => {
          this.$toastr.s("Note Added Successfully", "Success");
          this.notedBy = ''
          this.note = ''
          this.isAddingNote = false

          if (data.status === 403) {
            let logoutResponse = this.logout()
            if (logoutResponse === 1) {
              this.$router.push({ path: '/login' })
            }
          }
        })
        .catch(() => {
          // Revert the note addition on error
          this.restDetails.notes.pop()
          this.isAddingNote = false
        })
    }
  }
}
</script>

<style scoped>
 .backBtn{
    padding: 5px 20px;
    border-radius: 10px;
    text-align: center;
    float: right;
  }
  .btnPending, .btnInprogress, .btnComplete{
    color: #fff;
    border: unset;
    border-radius: .25rem;
    font-weight: bold;
    padding: 8px 16px;
  }
  .btnPending{
    background-color: #F4522D;
  }
  .btnInprogress{
    background-color: #FF9500;
  }
  .btnComplete{
    background-color: #57830d;
  }
  /* .btn:hover{
    background-color: unset !important; color: #fff;
  } */
</style>
